
import { useTranslation } from "react-i18next";

export const DataCapture = () => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left side - Image */}
          <div className="animate-fade-in">
            <img
              src="https://dynamico.cloud/assets/img/how-it-works-features.png"
              alt="Data Capture Features"
              className="w-full h-auto"
            />
          </div>
          
          {/* Right side - Text content */}
          <div className="space-y-6 animate-fade-in" style={{ animationDelay: "0.2s" }}>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              {t('dataCapture.title')}
            </h2>
            <ul className="space-y-4 text-lg text-gray-600">
              {(t('dataCapture.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
                <li key={index} className="flex items-start">
                  <span className="mr-2">•</span>
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
